export default "__VITE_ASSET__065034e2__"